import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { standardNameAndLevel } from '../../../../shared/constants/scanning';
import { FeatureFlagService } from '../feature-flag/feature-flag.service';
import { FeatureFlagCollection } from '../../../../shared/interfaces/feature-flag.interface';

@Injectable({
  providedIn: 'root',
})
export class A11yStandardsService {
  constructor(private readonly featureFlagService: FeatureFlagService) {}

  getFilteredStandards(): Observable<standardNameAndLevel[]> {
    return this.featureFlagService.variation$(FeatureFlagCollection.non_wcag_standards_automated, false).pipe(
      map(Boolean),
      map((isNonWcagStandardsAutomated: boolean) => {
        const options = Object.values(standardNameAndLevel).filter((standard: standardNameAndLevel) => {
          // Always disabled for now
          if (standard === standardNameAndLevel.essential_v10_A) {
            return false;
          }

          // Disable standards under feature flag
          if (
            !isNonWcagStandardsAutomated &&
            [standardNameAndLevel.SECTION_508, standardNameAndLevel.EN_301_549].includes(standard)
          ) {
            return false;
          }

          return true;
        });

        return options;
      }),
    );
  }
}
